import React from 'react'
import './About.css'
const About = () => {
    return (
        <div className="Msection">
            <div className="about">
                <div className="pic">
                    <img src={require('../../image/aboutFinal.jpg')} alt="Profile2" width="70%" />
                </div>
                <div className="aboutme">
                    <div className="aboutme1">
                        <h2>About Me</h2>
                        <span>My name is Gulshan Sharma. I belong to Bihar, currently living in New Delhi. Passionate Web developer with knowledge of medern technology. I have learned Full stack Web Development in Masai School. Great Team Player with ability of problem solving. I look forward to join a company where I can contribute to individual as well as company growth.</span>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default About